import React, { useEffect, useState } from "react";
import { Button } from "@aws-amplify/ui-react";
import FullNameContainer from "../Components/FullNameContainer";
import { determineUserType } from "../../../utils/UserType";
import EmailContainer from "../Components/EmailContainer";
import AlreadyHaveAnAccount from "../Components/AlreadyHaveAnAccount";
import { buildCurrentLocation, splitName, SS_REDIRECT_URL } from "../GetStarted.service";
import { Container } from "./Styled";
import { useLocation, useNavigate } from "react-router-dom";


const StepOne = ({ email, setEmail, fullName, setFullName, setProgress }: any) => {
    const navigate = useNavigate();
    const { search } = useLocation();
    const userType = determineUserType();
    const [fieldsNotEmpty,setFieldsNotEmpty]= useState(false);

    useEffect(()=> {
        setProgress('10');
        window.dataLayer.push({event: "page_view",
            page_location: buildCurrentLocation,
            page_title: "SignUp Step 1"
          });
    }, [])

    useEffect(()=> {
        const [firstName, lastName] = splitName(fullName.replace(/^\s+|\s+$/g, ''));
        if (email && fullName) {
            setFieldsNotEmpty(true);
        }
        else{
            setFieldsNotEmpty(false);
        }
    },[email, fullName]);

    const isMailValid = (email: string): boolean => {
        return email.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ) !== null
    }

    const isNameValid = (fullName: string): boolean => {
        return fullName.match(/^[a-zA-Z][a-z ,.'-]+$/i) !== null
    }

    const changeStep = async () => {
        const [firstName, lastName] = splitName(fullName);
        let validName = true
        let validMail = true
        if (! isMailValid(email)) {
            validMail = false
            window.dataLayer.push({event: "signup_set_account_fail",
                fail_reason: "Invalid email"
            });
        }
        if (! isNameValid(fullName)) {
            validName = false
        }
        // await addContact(email, firstName, lastName)
        if (validMail && validName) {
            const lowerEmail = email.toLowerCase();
            localStorage.setItem("userEmail", lowerEmail);
            localStorage.setItem("userFName", firstName);
            localStorage.setItem("userLName", lastName);
            setEmail(lowerEmail)
            window.dataLayer.push({event: "signup_set_account_success",
                email: email,
                full_Name: fullName
            });
            navigate("/self-service/verticals" + search);
        }
    }

    return (
        <Container>
            <div className="step-container">
                <div className="BlackTitle">Get started with Verbit</div>
                <EmailContainer email={email} setEmail={setEmail} isMailValid={isMailValid} />
                <FullNameContainer fullName={fullName} setFullName={setFullName} isNameValid={isNameValid} />
                <Button
                    className="customButton"
                    isFullWidth={true}
                    onClick={changeStep}
                    placeholder={undefined}
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                >
                    Let's Start
                </Button>
                <AlreadyHaveAnAccount redirectTo={SS_REDIRECT_URL}/>
                <div className="PrivacyPolicyLink">I agree to the collection and use of my information for receiving marketing communications about Verbit's products, services, and updates. Please Review our&nbsp;
                    <a
                        href="https://verbit.ai/privacy-policy/"
                        target="_blank"
                        rel="noreferrer"
                        id="SupportLink"
                        tabIndex={0}
                        className= "PrivacyPolicy"
                        aria-label="Contact Support"
                        role="button">
                        Privacy Policy
                    </a>
                </div>
            </div>
        </Container>
    );
};

export default StepOne;
